<template>
  <div class="container-fluid">
    <div class="row">
      <div
        class="es-xs-12 es-md-6 es-lg-6 u-padding-0 u-margin-0 u-border-right"
      >
        <Sections
          ref="sections"
          :init-cycle="cycle"
          @get:result="updateResult"
          @update:refrigerant="updateRefrigerant"
        />
      </div>
      <div
        class="es-xs-12 es-md-6 es-lg-6 col-sticky u-top-0 u-padding-0 u-margin-0"
      >
        <Result
          @show:alertBox="showAlertBox"
          @get:form="getForm"
          :refrigerantId="refrigerantId"
          :result="result"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Sections from "./Sections.vue";
import Result from "./Result.vue";
export default {
  components: {
    Sections,
    Result,
  },
  props: {
    cycle: {
      type: Object,
    },
  },
  data() {
    return {
      refrigerantId: 8,
      result: {
        status: false,
        te: null,
        tc: null,
        condFanAirFlow: null,
        evap_mutlak_debi: null,
        cond_mutlak_debi: null,
        condenserResponse: {
          capacity: null,
          airPressureDrop: null,
          airTemperatureWetbulbOutlet: null,
          airTemperatureOutlet: null,
          airVelocityOutlet: null,
          airHumidityOutlet: null,
          passCount: null,
          lDmax: null,
          hr: null,
          lh: null,
          th: null,
          fldPressureDrop: null,
          fldMassFlow: null,
          condensatedFlow: null,
          fldPressureDropKelvin: null,
          exceptionMessage: null,
          isSuccess: null,
        },
        evaporatorResponse: {
          capacity: null,
          airPressureDrop: null,
          airTemperatureWetbulbOutlet: null,
          airTemperatureOutlet: null,
          airVelocityOutlet: null,
          airHumidityOutlet: null,
          passCount: null,
          lDmax: null,
          hr: null,
          lh: null,
          th: null,
          fldPressureDrop: null,
          fldMassFlow: null,
          condensatedFlow: null,
          fldPressureDropKelvin: null,
          exceptionMessage: null,
          isSuccess: null,
        },
        coolPropCalculateResponse: {
          coolprop_Cond_Temp: null,
          coolprop_Evap_Temp: null,
          coolprop_LPressure: null,
          coolprop_HPressure: null,
          coolprop_DischargeTemp: null,
          h1_evap_out_comp_in: null,
          h2_comp_out_cond_in: null,
          h3_conp_out_exp_in: null,
          h4_exp_out_evap_in: null,
          x4: null,
          cycle_work: null,
          cycle_mass_flow: null,
          cycle_cooling: null,
          cycle_rej_heat: null,
          coolprop_Subcool: null,
          coolprop_Superheat: null,
          evap_sensible_capacity: null,
        },
        compressorResponse: {
          comp_ref_capacity: null,
          comp_cond_capacity: null,
          comp_ref_mass_flow: null,
          comp_electrical_power: null,
          comp_eer: null,
          comp_current: null,
        },
      },
    };
  },
  methods: {
    getForm(callback) {
      const response = this.$refs.sections.getForm();
      if (!response)
        return this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t(`cyclesForm.selectRequirements`),
          variant: "danger",
          duration: 2500,
        });
      console.log(response, "reeeeeeepo");

      this.updateResult({ form: response });
      setTimeout(() => {
        callback();
      }, 250);
    },
    updateRefrigerant(refrigerantId) {
      this.refrigerantId = refrigerantId;
    },
    updateResult(result) {
      this.result = result;
    },
    showAlertBox(response) {
      const text =
        response.exceptionMessage ||
        this.$t(`message.${response.message}.description`);
      this.$refs.sections.showAlertBox(text, "danger");
    },
  },
};
</script>
